import bicepsBrachiiImage from '@assets/images/muscle-icons/biceps-brachii.png'
import brachialisImage from '@assets/images/muscle-icons/brachialis.png'
import brachioradialisImage from '@assets/images/muscle-icons/brachioradialis.png'
import calvesImage from '@assets/images/muscle-icons/calves.png'
import deltoidAnteriorImage from '@assets/images/muscle-icons/deltoid-anterior.png'
import deltoidPosteriorImage from '@assets/images/muscle-icons/deltoid-posterior.png'
import deltoidImage from '@assets/images/muscle-icons/deltoid.png'
import erectorSpinaeBackImage from '@assets/images/muscle-icons/erector-spinae-back.png'
import erectorSpinaeCoreImage from '@assets/images/muscle-icons/erector-spinae-core.png'
import forearmMusclesImage from '@assets/images/muscle-icons/forearm-muscles.png'
import gastrocnemiusImage from '@assets/images/muscle-icons/gastrocnemius.png'
import glutesImage from '@assets/images/muscle-icons/glutes.png'
import hamstringsImage from '@assets/images/muscle-icons/hamstrings.png'
import iliopsoasCoreImage from '@assets/images/muscle-icons/iliopsoas-core.png'
import iliopsoasLegsImage from '@assets/images/muscle-icons/iliopsoas-legs.png'
import innerChestImage from '@assets/images/muscle-icons/inner-chest.png'
import latissimusDorsiImage from '@assets/images/muscle-icons/latissimus-dorsi.png'
import lowerBackMusclesImage from '@assets/images/muscle-icons/lower-back-muscles.png'
import lowerTrapeziusImage from '@assets/images/muscle-icons/lower-trapezius.png'
import obliquesImage from '@assets/images/muscle-icons/obliques.png'
import pectoralisMajorImage from '@assets/images/muscle-icons/pectoralis-major.png'
import quadricepsImage from '@assets/images/muscle-icons/quadriceps.png'
import rectusAbdominisImage from '@assets/images/muscle-icons/rectus-abdominis.png'
import rhomboidsImage from '@assets/images/muscle-icons/rhomboids.png'
import soleusImage from '@assets/images/muscle-icons/soleus.png'
import transversusAbdominisImage from '@assets/images/muscle-icons/transversus-abdominis.png'
import trapeziusImage from '@assets/images/muscle-icons/trapezius.png'
import tricepsBrachiiImage from '@assets/images/muscle-icons/triceps-brachii.png'
import upperChestImage from '@assets/images/muscle-icons/upper-chest.png'
import upperTrapeziusImage from '@assets/images/muscle-icons/upper-trapezius.png'

export type MobileMuscleVisual = {
	canonicalCode: string
	name: string
	image: string
}

export const mobileMuscleVisualCatalog: Record<string, MobileMuscleVisual> = {
	upper_chest: { canonicalCode: 'upper_chest', name: 'Верхняя часть грудных мышц', image: upperChestImage },
	inner_chest: { canonicalCode: 'inner_chest', name: 'Внутренняя часть грудных мышц', image: innerChestImage },
	pectoralis_major: { canonicalCode: 'pectoralis_major', name: 'Грудные мышцы', image: pectoralisMajorImage },
	obliques: { canonicalCode: 'obliques', name: 'Косые мышцы живота', image: obliquesImage },
	transversus_abdominis: { canonicalCode: 'transversus_abdominis', name: 'Поперечная мышца живота', image: transversusAbdominisImage },
	rectus_abdominis: { canonicalCode: 'rectus_abdominis', name: 'Прямая мышца живота', image: rectusAbdominisImage },
	erector_spinae_core: { canonicalCode: 'erector_spinae_core', name: 'Разгибатели спины', image: erectorSpinaeCoreImage },
	iliopsoas_core: { canonicalCode: 'iliopsoas_core', name: 'Подвздошно-поясничная мышца', image: iliopsoasCoreImage },
	hamstrings: { canonicalCode: 'hamstrings', name: 'Бицепсы бедра', image: hamstringsImage },
	quadriceps: { canonicalCode: 'quadriceps', name: 'Квадрицепсы', image: quadricepsImage },
	calves: { canonicalCode: 'calves', name: 'Мышцы голени', image: calvesImage },
	iliopsoas_legs: { canonicalCode: 'iliopsoas_legs', name: 'Подвздошно-поясничная мышца', image: iliopsoasLegsImage },
	gastrocnemius: { canonicalCode: 'gastrocnemius', name: 'Икроножные мышцы', image: gastrocnemiusImage },
	soleus: { canonicalCode: 'soleus', name: 'Камбаловидная мышца', image: soleusImage },
	glutes: { canonicalCode: 'glutes', name: 'Ягодичные мышцы', image: glutesImage },
	deltoid: { canonicalCode: 'deltoid', name: 'Дельтовидные мышцы', image: deltoidImage },
	deltoid_posterior: { canonicalCode: 'deltoid_posterior', name: 'Задние дельтовидные мышцы', image: deltoidPosteriorImage },
	deltoid_anterior: { canonicalCode: 'deltoid_anterior', name: 'Передние дельтовидные мышцы', image: deltoidAnteriorImage },
	biceps_brachii: { canonicalCode: 'biceps_brachii', name: 'Бицепсы', image: bicepsBrachiiImage },
	brachialis: { canonicalCode: 'brachialis', name: 'Плечевая мышца', image: brachialisImage },
	brachioradialis: { canonicalCode: 'brachioradialis', name: 'Плечелучевая мышца', image: brachioradialisImage },
	forearm_muscles: { canonicalCode: 'forearm_muscles', name: 'Мышцы предплечья', image: forearmMusclesImage },
	triceps_brachii: { canonicalCode: 'triceps_brachii', name: 'Трицепсы', image: tricepsBrachiiImage },
	upper_trapezius: { canonicalCode: 'upper_trapezius', name: 'Верхняя часть трапеций', image: upperTrapeziusImage },
	lower_trapezius: { canonicalCode: 'lower_trapezius', name: 'Нижняя часть трапеций', image: lowerTrapeziusImage },
	erector_spinae: { canonicalCode: 'erector_spinae', name: 'Разгибатели спины', image: erectorSpinaeBackImage },
	trapezius: { canonicalCode: 'trapezius', name: 'Трапеции', image: trapeziusImage },
	latissimus_dorsi: { canonicalCode: 'latissimus_dorsi', name: 'Широчайшие мышцы спины', image: latissimusDorsiImage },
	lower_back_muscles: { canonicalCode: 'lower_back_muscles', name: 'Мышцы нижней части спины', image: lowerBackMusclesImage },
	rhomboids: { canonicalCode: 'rhomboids', name: 'Ромбовидные мышцы', image: rhomboidsImage },
}

export const adminMuscleVisualAliases: Record<string, string> = {
	chest: 'pectoralis_major',
	upper_back: 'trapezius',
	lats: 'latissimus_dorsi',
	lower_back: 'lower_back_muscles',
	shoulders: 'deltoid',
	biceps: 'biceps_brachii',
	triceps: 'triceps_brachii',
	forearms: 'forearm_muscles',
	abs: 'rectus_abdominis',
	obliques: 'obliques',
	glutes: 'glutes',
	quadriceps: 'quadriceps',
	hamstrings: 'hamstrings',
	calves: 'calves',
	hip_flexors: 'iliopsoas_legs',
}

export const currentAdminMuscleCodes = Object.freeze(Object.keys(adminMuscleVisualAliases))

export const resolveMobileMuscleVisual = (code: string): MobileMuscleVisual | null => {
	const normalized = code.trim().toLowerCase()
	const canonicalCode = mobileMuscleVisualCatalog[normalized]
		? normalized
		: adminMuscleVisualAliases[normalized]
	return canonicalCode ? mobileMuscleVisualCatalog[canonicalCode] ?? null : null
}
